<template>
  <div class="push-msg-content">
    <el-form
      ref="form"
      :inline="true"
      label-position="right"
      :model="form"
      label-width="80px"
      class="push-msg-fro"
    >
      <el-form-item>
        <el-select
          v-model="form.tagid"
          filterable
          placeholder="用户标签"
          clearable>
          <el-option
            v-for="item in wxUserTags"
            :key="item.id"
            :label="item.name"
            :value="item.id+''"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.nickname"
          placeholder="昵称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.province"
          placeholder="省份"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.city"
          placeholder="城市"
          clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.remark"
          placeholder="备注"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.qrScene"
          placeholder="扫码场景值"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="searchHandle"
        >搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="text-bold">本消息将发送给：</div>
    <div
      class="user-list"
      v-loading="wxUsersLoading">
      <div class="user-card"
           v-for="item in wxUserList"
           :key="item.openid"
      >
        <el-avatar :src="item.headimgurl"></el-avatar>
        <div class="nickname">{{item.nickname}}</div>
      </div>
      <div class="text-bold">
        <span v-show="totalCount>10">...</span>
        等共<span class="text-success">{{totalCount}}</span>个用户
      </div>
    </div>
    <div class="margin-top text-bold">消息预览：</div>
    <div class="margin-top-xs">
      <el-input
        type="textarea"
        disabled autosize
        v-model="msgReview"
        placeholder="模版"
      ></el-input>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

let origin = {
  page:1,
  sidx: 'subscribe_time',
  order: 'desc',
  tagid:'',
  nickname: '',
  city:'',
  province:'',
  remark:'',
  qrScene:''
}
export default {
  name: "pushMsgForm",
  components: {
  },
  props: {
    wxUserTagName:{
      type:String,
      required:false
    }
  },
  data() {
    return {
      form: {
        page:1,
        sidx: 'subscribe_time',
        order: 'desc',
        tagid:'',
        nickname: '',
        city:'',
        province:'',
        remark:'',
        qrScene:''
      },
      wxUserTags: [],
      wxUserList:[],
      totalCount: 0,
      wxUsersLoading: false,
      msgTemplate:{},
      sending: false,
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    },
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.fetchData();
      }
    }
  },
  computed: {
    ...mapGetters(['themeColor','userInfo','selectedAppid']),
    msgReview(){
      if(!this.msgTemplate.data) return "";
      let content = this.msgTemplate.content;
      this.msgTemplate.data.forEach(item=>{
        content = content.replace("{{"+item.name+".DATA}}",item.value)
      })
      return content
    }
  },
  created(){
  },
  mounted(){
    this.fetchData();
  },
  methods: {
    init(msgTemplate){
      if(!msgTemplate || !msgTemplate.templateId){
        this.$message.error('消息模板无效')
        return
      }
      if(!msgTemplate.data || !(msgTemplate.data instanceof Array)){
        this.$message.error('请现配置此模板填充数据')
        return
      }
      this.$emit('open-dialog')
      this.msgTemplate = msgTemplate;
    },
    fetchData(){
      this.getWxUserTags().then((taglist)=>{
        if(this.wxUserTagName){
          let tagItem = taglist.find(tag=>tag.name==this.wxUserTagName)
          if(tagItem) {
            this.form.tagid = tagItem.id+''
          }
        }
        this.getWxUsers()
      });
    },
    getWxUserTags() {
      return new Promise((resolve,reject)=>{
        this.$http({
          url: '/wx/manage/wxUserTags/list',
          method: 'get',
        }).then((data) => {
          if (data.code === 200) {
            this.wxUserTags = data.list;
            resolve(data.list)
          } else if(data.code !== 400){
            this.$message.error(data.msg)
            reject(data.msg)
          }
        }).catch(err=>reject(err))
      })
    },
    searchHandle(){
      this.getWxUsers();
    },
    getWxUsers() {
      this.wxUsersLoading = true
      this.$http({
        url: '/wx/manage/wxUser/list',
        method: 'get',
        params: this.form
      }).then((data) => {
        if (data.code === 200) {
          this.wxUserList = data.page.list
          this.totalCount = data.page.totalCount
        } else if(data.code !== 400) {
          this.$message.error(data.msg)
        }
        this.wxUsersLoading = false
      })
    },
    reset(){
      this.form = {
        page:1,
        sidx: 'subscribe_time',
        order: 'desc',
        tagid:'',
        nickname: '',
        city:'',
        province:'',
        remark:'',
        qrScene:''
      }
    },
    assigen(data){
      // todo
      this.form.id = data.id;
      this.form.strategyId = data.strategyId;
      this.form.contentType = data.contentType;
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      if(this.sending)return
      this.sending=true
      this.$http({
        url: '/wx/manage/msgTemplate/sendMsgBatch',
        method: 'post',
        data:{
          wxUserFilterParams : this.form,
          templateId : this.msgTemplate.templateId,
          url : this.msgTemplate.url,
          miniprogram : this.msgTemplate.miniprogram,
          data : this.msgTemplate.data,
        }
      }).then((data) => {
        this.sending = false
        if (data.code === 200) {
          this.$emit('send-success');
          this.$message.success("消息将在后台发送")
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    catchData(content){
      this.form.contentEdit = content;
    }
  },
}
</script>

<style lang="scss" scoped>
.push-msg-content {
  .user-list{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .user-card{
    overflow: hidden;
    max-width: 60px;
    margin: 5px;
    text-align: center;
  }
  .nickname{
    color: #999999;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}
</style>
